import { Link } from "@mui/material";

const MailToLink = ({ children, email, ...rest }) => (
  <Link href={`mailto:${email}`} underline="none" {...rest}>
    {children || email}
  </Link>
);

export default MailToLink;
